import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad0808ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "activity-header" }
const _hoisted_4 = { class: "activity-title" }
const _hoisted_5 = { style: {"font-size":"2rem"} }
const _hoisted_6 = { class: "slide" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "slide" }
const _hoisted_9 = { class: "container" }

import TrendSizes from './TrendSizes.vue'
import { DataRelevance } from '@/entities/DataRelevance'
import Structure from './Structure.vue'
import { DataRange } from '@/entities/DataRange'
import { AvailableYear, ReportActivitySegment, ReportTarget } from '../../model/types/report'
import { computed } from 'vue'
import { useAppStore } from '@/shared/config/storeConfig/storeConfig'
import { useActivityType } from '../../model/hooks/useActivityType'
import { productCategories } from '@/shared/consts/common'


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivitySegment',
  props: {
    year: null,
    activitySegment: null,
    reportTarget: null
  },
  setup(__props: any) {

const props = __props as {
	year: AvailableYear,
	activitySegment: ReportActivitySegment,
	reportTarget: ReportTarget,
};



const store = useAppStore()
// noinspection TypeScriptUnresolvedReference
const currentProductName = computed(() => productCategories.find(item => item.id === store.state.reports.subSection)?.name)
const { getActivityType } = useActivityType()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, [
          _createTextVNode(_toDisplayString(__props.activitySegment.name) + ": ", 1),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(currentProductName)), 1),
          _createVNode(_unref(DataRange))
        ]),
        _createVNode(_unref(DataRelevance))
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.activitySegment.children, (productType) => {
      return (_openBlock(), _createElementBlock("div", {
        key: productType.id
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(Structure, {
              data: _unref(getActivityType)(props.year, __props.activitySegment.id, productType.id),
              year: props.year,
              target: props.reportTarget,
              type: __props.activitySegment.id,
              "type-of-product": productType.id,
              "instant-init": ""
            }, null, 8, ["data", "year", "target", "type", "type-of-product"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(TrendSizes, {
              "instant-init": "",
              year: props.year,
              activityType: __props.activitySegment.id,
              "type-of-product": productType.id
            }, null, 8, ["year", "activityType", "type-of-product"])
          ])
        ])
      ]))
    }), 128))
  ]))
}
}

})